<template>
  <b-button
    variant="warning"
    @click="update"
  >
    <b-icon
      icon="arrow90deg-up"
    />
    設定を変更
  </b-button>
</template>

<script>
export default {
  methods: {
    update () {
      this.$store.dispatch('modal/setUpdate', async () => {
        this.$store.dispatch('loading/show')
        const result = await this.$store.dispatch('settings/siteConfig/update')
        this.$store.dispatch('loading/hide')

        if (result) {
          this.$store.dispatch('toast/show', {
            content: '更新が完了しました。',
            title: 'サイト設定の更新'
          })
        }
      })
    }
  }
}
</script>
